import React from 'react'
import ContentLoader from 'react-content-loader'

const MyLoader = () => (
    <ContentLoader
        speed={4}
        width={220}
        height={380}
        viewBox="0 0 220 380"
        backgroundColor="#f1f1f1"
        foregroundColor="#fcfcfc"
    >
        <rect x="10" y="10" rx="0" ry="0" width="200" height="80" />
        <rect x="10" y="105" rx="3" ry="3" width="30" height="18" />
        <rect x="10" y="130" rx="3" ry="3" width="170" height="13" />
        <rect x="10" y="155" rx="3" ry="3" width="50" height="18" />
        <rect x="10" y="180" rx="3" ry="3" width="170" height="26" />
        <rect x="10" y="215" rx="3" ry="3" width="30" height="18" />
        <rect x="10" y="240" rx="3" ry="3" width="150" height="13" />
        <rect x="10" y="265" rx="3" ry="3" width="60" height="18" />
        <rect x="10" y="290" rx="3" ry="3" width="80" height="13" />
        <rect x="10" y="315" rx="3" ry="3" width="40" height="18" />
        <rect x="10" y="340" rx="3" ry="3" width="170" height="13" />
        <rect x="10" y="360" rx="3" ry="3" width="170" height="13" />
    </ContentLoader>
)

export default MyLoader



// WEBPACK FOOTER //
// ./src/aside_medium/aside_loader.js